export default "<router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n"